import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { useDebounceEffect } from 'ahooks';
import { HelperCore } from '@/common/dependencies';
import McpToolsItem from './tools-item';
import McpChatText from './chat-text';
import XiaohongshuShop from './xiaohongshu-shop';
import XiaohongshuMedia from './xiaohongshu-media';
import XiaohongshuNote from './xiaohongshu-note';
import McpSummary from './summary';
import McpSummaryLink from './summary-link';
import McpToolsCost from './tools-cost';
import { useMemo } from 'react';

const McpTools = observer((props) => {
  const {
    className = '',
    mcpStore,
    events,
    messageItem,
    onRenew,
    handleSend,
    isMcpShare,
    isLastMessage,
  } = props;

  if(!events?.length){
    return null;
  }

  const {
    chatStore,
    currentPanelId,
    panelMessageId,
  } = mcpStore;

  const hideLevel1 = useMemo(() => {
    try{
      const list = events.filter(item => item.type == "planStep");
      const result = list.length && list.every(item => item.hideTitle);
      return result;
    } catch(e){}

    return false;
  }, [events]);

  
  // 自动滚动到显示当前卡片
  useDebounceEffect(() => {
    const id = `${panelMessageId || ''}_${currentPanelId || ''}`;
    const currentDom = document.querySelector(`[data-id="${id}"]`);
    if(currentDom){
      currentDom.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [currentPanelId, panelMessageId], { wait: 200 });

  return (
    <div 
      className={`mcp-tools-container mt-18px first-of-type:mt-0 flex flex-col ${hideLevel1 ? "mcp-tools-hide-level1" : ""} ${className}`}
      style={{
        gap : hideLevel1 ? '0px' : 'var(--nw-mcp-card-sep)',
      }}>
      {
        events.map((item, index) => {
          // 不展示“待执行”节点，20250618
          if (item.stepStatus === 'waiting') {
            return null;
          }
          
          const isLast = index == events.length - 1;
          const { type } = item;
          const sepClassName = hideLevel1 && index ? 'mt-0px' : '';

          switch(type){
            case "chat":
            case "clarification":
            {
              return (
                <McpChatText 
                  key={`${index}_${item.content}`} 
                  event={item}
                  className={sepClassName}>
                  {item.content}
                </McpChatText>
              )
            }
            case "html":{
              return (
                <McpSummaryLink 
                  key={`html_${index}`}
                  mcpStore={mcpStore} 
                  attachment={item} 
                  event={item} 
                  messageItem={messageItem}
                  >
                </McpSummaryLink>
              )
            }
            case "agentStatus":
            case "convertFinalSummary": 
            case "attachments":{
              const event = HelperCore.copyObj(item);
              // debug html
              // if(HelperCore.IS_LOCAL){
              //   event.attachments = event.attachments || [];
              //   if(!event.attachments.some(item => item.contentType == "html")){
              //     event.attachments.push({
              //       contentType : "html",
              //       content : "<p>P</p>",
              //       url : "https://so.com",
              //       title : "html title",
              //     })
              //   }
              // }

              // debug word
              // if(HelperCore.IS_LOCAL){
              //   event.attachments = event.attachments || [];
              //   if(!event.attachments.some(item => item.contentType == "docx")){
              //     event.attachments.push({
              //       contentType : "docx",
              //       content : "doc 内容",
              //       url : "https://down.zhaomi.cn/web/assets/word/%E6%B3%B0%E8%AF%AD%E6%96%87%E6%A1%A3.docx",
              //       title : "doc title",
              //       type : "file",
              //     })
              //   }
              // }

              // debug video
              // if(HelperCore.IS_LOCAL){
              //   event.attachments = event.attachments || [];
              //   if(!event.attachments.some(item => item.contentType == "video")){
              //     event.attachments.push({
              //       contentType : "video",
              //       content : "",
              //       url : "https://down.zhaomi.cn/web/assets/video/16_9_1.mp4",
              //       title : "video title",
              //       type : "file",
              //     })
              //   }
              // }

              return (
                <McpSummary
                  key={`final_${type}_${index}`}
                  messageItem={messageItem}
                  mcpStore={mcpStore}
                  isAITyping={chatStore?.isAITyping}
                  event={event}
                  onRenew={onRenew}
                  isLastMessage={isLastMessage}
                  type={type}
                  handleSend={handleSend}
                />
              )
            }
            // 小红书笔记
            case "notes":
              return (
                <XiaohongshuNote key={`${type}_${index}`} list={item.list}/>
              )
            // 小红书视频
            case "media": {
              return (
                <XiaohongshuMedia key={`${type}_${index}`} list={item.list} notesNum={item.notes_num} />
              )
            }
            // 导购
            case "recommended_goods": {
              return (
                <XiaohongshuShop key={`${type}_${index}`} list={item.content} status={item.status} action_name={item.action_name} request_id={item.request_id} mcpStore={mcpStore} isMcpShare={isMcpShare} is_doing={chatStore.lastMessage?.is_doing} />
              )
            }
            // 消耗
            case "taskDetail": {
              return (
                <McpToolsCost key={`${type}_${index}`} item={item} mcpStore={mcpStore} className={sepClassName} />
              )
            }
          }


          return (
            <McpToolsItem key={`${index}_${item.planStepId || ''}`} mcpStore={mcpStore} item={item} isLast={isLast} messageItem={messageItem} onRenew={onRenew} index={index} handleSend={handleSend}/>
          )
        })
      }
    </div>
  )
});
export default McpTools;